import { NgModule } from "@angular/core";
import { S25IconComponent } from "../s25-icon/s25.icon.component";
import { S25OptModule } from "../s25-opt/s25.opt.module";
import { S25LoadingInlineModule } from "../s25-loading/s25.loading.inline.module";
import { S25ObjectDetailsComponent } from "./s25.object.details.component";
import { S25ObjectDetailsGeneralComponent } from "./general-details/s25.object.details.general.component";
import { S25EditableModule } from "../s25-editable/s25.editable.module";
import { ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { S25ContactDetailsUserAccountComponent } from "./contact/user-account/s25.contact.details.user.account";
import { S25RadioModule } from "../s25-radio/s25.radio.module";
import { S25DropdownPaginatedModule } from "../s25-dropdown/s25.dropdown.paginated.module";
import { S25FadingSuccessMsgComponent } from "../s25-fading-success-msg/s25.fading.success.msg.component";
import { S25ButtonComponent } from "../../standalone/s25.button.component";
import { S25ObjectDetailsEditableTextComponent } from "./s25.object.details.editable.text.component";
import { S25EditableContactOrgsComponent } from "./contact/editable-orgs/s25.editable.contact.orgs.component";
import { S25ItemModule } from "../s25-item/s25.item.module";
import { S25ObjectDetailsAddressComponent } from "./address/s25.object.details.address.component";
import { S25AddressModule } from "../s25-address/s25.address.module";
import { S25ObjectDetailsCustomAttrComponent } from "./custom-attrs/s25.object.details.custom.attr.component";
import { S25PipesModule } from "../../pipes/s25.pipes.module";
import { S25PanelsModule } from "../s25-panel/s25.panels.module";
import { S25LocationDetailsHoursComponent } from "./location/s25.location.details.hours.component";
import { S25ToggleButtonModule } from "../s25-toggle-button/s25.toggle.button.module";
import { S25TimepickerModule } from "../s25-timepicker/s25.timepicker.module";
import { S25LocationDetailsLayoutsComponent } from "./location/s25.location.details.layouts.component";
import { S25TableModule } from "../s25-table/s25.table.module";
import { S25ObjectDetailsRelationshipsComponent } from "./s25.object.details.relationships.component";
import { S25IconButtonComponent } from "../../standalone/s25.icon.button.component";
import { S25ObjectDetailsItemPlainComponent } from "./s25.object.details.item.plain.component";
import { S25ImageModule } from "../s25-image/s25.image.module";
import { S25ChartsModule } from "../s25-charts/s25.charts.module";
import { S25LocationDetailsLayoutDetailsComponent } from "./location/s25.location.details.layout.details.component";
import { S25ObjectDetailsService } from "./s25.object.details.service";
import { S25EditableInventoryComponent } from "./resource/s25.editable.inventory.component";
import { S25EvDetailsModule } from "./event/s25.ev.details.module";
import { S25MultiselectModule } from "../s25-multiselect/s25-multiselect.module";
import { S25InfoMessageModule } from "../s25-info-message/s25.info.message.module";
import { S25CheckboxModule } from "../s25-checkbox/s25.checkbox.module";
import { CapitalizeBoundariesPipe } from "../../pipes/s25.pipes";

@NgModule({
    imports: [
        S25OptModule,
        S25LoadingInlineModule,
        S25IconComponent,
        S25EditableModule,
        ReactiveFormsModule,
        CommonModule,
        S25PanelsModule,
        S25RadioModule,
        S25DropdownPaginatedModule,
        S25FadingSuccessMsgComponent,
        S25ButtonComponent,
        S25ItemModule,
        S25AddressModule,
        S25PipesModule,
        S25ToggleButtonModule,
        S25TimepickerModule,
        S25TableModule,
        S25IconButtonComponent,
        S25ImageModule,
        S25ChartsModule,
        S25EvDetailsModule,
        S25MultiselectModule,
        S25InfoMessageModule,
        S25CheckboxModule,
        CapitalizeBoundariesPipe,
    ],
    exports: [S25ObjectDetailsComponent, S25ObjectDetailsCustomAttrComponent],
    declarations: [
        S25ObjectDetailsComponent,
        S25ObjectDetailsGeneralComponent,
        S25ContactDetailsUserAccountComponent,
        S25ObjectDetailsEditableTextComponent,
        S25EditableContactOrgsComponent,
        S25ObjectDetailsAddressComponent,
        S25ObjectDetailsCustomAttrComponent,
        S25LocationDetailsHoursComponent,
        S25LocationDetailsLayoutsComponent,
        S25ObjectDetailsRelationshipsComponent,
        S25ObjectDetailsItemPlainComponent,
        S25LocationDetailsLayoutDetailsComponent,
        S25EditableInventoryComponent,
    ],
    providers: [S25ObjectDetailsComponent],
})
export class S25ObjectDetailsModule {}
